import { render, staticRenderFns } from "./QrComponent.vue?vue&type=template&id=13820c2c&scoped=true"
import script from "./QrComponent.vue?vue&type=script&lang=js"
export * from "./QrComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13820c2c",
  null
  
)

export default component.exports